import React, { useState } from 'react';

import { AddIcon } from 'constants/icon.constants';
import { DataTableAction } from 'components/DataTable';
import { ENTITY_TASK } from 'constants/schemas';
import NewTaskDialog from 'components/NewTaskDialog';
import PropTypes from 'prop-types';
import { formatType } from 'utils/entity.utils';

function ActionAddTask(props) {
  const { initState } = props;
  const [dialogOpen, setDialogOpen] = useState(false);
  return (
    <>
      <DataTableAction
        label={`New ${formatType(ENTITY_TASK, { template: initState?.is_template })}`}
        icon={<AddIcon />}
        onClick={() => setDialogOpen(true)}
      />
      <NewTaskDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        initState={initState}
      />
    </>
  );
}

ActionAddTask.propTypes = {
  initState: PropTypes.object,
};

export default ActionAddTask;
